<template>
    <b-row>
        <b-col sm="10">
            <div class="row column header" id="app">
                <b-row>
                    <b-col sm="12 text-left mt-3">
                        <h4 class="trip-title">{{selectedEvent.title}}</h4>
                        <div class="mt-2">Depart in the loby at 2pm drop-off the front entrancy of kroger.</div>
                        <div>Pickup will be 3:30 at the same dropoff location.</div>
                    </b-col>

                    <b-col sm="12">
                        <input type="text" v-model="apiToken" placeholder="Please enter api token here"/>
                    </b-col>
                    <b-col sm="12">
                        <input type="text" v-model="apiApplicationKey" placeholder="Please enter api ApplicationKey here"/>
                    </b-col>

                    <b-col sm="12">
                        <div class="medium-6 medium-offset-3 ctrl">
                              <!-- <form class="searchForm" v-on:submit.prevent="submitSearch">
                              <input type="text" v-model="searchQuery" @input="typing = true , bookTrip = null" placeholder="Resident name">
                              <span v-show="searchQuery" class="removeInput" @click="removeSearchQuery">+</span>
                            </form>     -->
                          <!-- <model-list-select
                            :list="userList"
                            v-model="objectItem"
                            option-value= "badgeNumber"
                            option-text="badgenumber"
                            placeholder="select item">
                          </model-list-select> -->

                          [{{hoveredIndex}}]  selected: [{{selected}}] / user: <span v-if="user" >{{user.badgeTitle || ""}} {{user.accountNumber}} : {{user.badgeNumber}}</span>
                        <vue-simple-suggest
                            v-model="user"
                            display-attribute="badgeTitle"
                            value-attribute="badgeTitle"
                            :list="submitSearch"
                            :debounce=200
                            :min-length=1
                            mode='select'
                          >
<hr>
                          <input placeholder="Enter your search" type="search">
                          <div slot="suggestion-item" slot-scope="{suggestion}">
                            <div v-if="suggestion">{{ suggestion.badgeTitle || "" }} <span v-if="suggestion.roomNumber">/ Room #: {{ suggestion.roomNumber}}</span></div>
                          </div>

                          </vue-simple-suggest>

                        </div>
                    </b-col>
                    <!-- <b-col sm="12">
                        <div class="searchResult" v-show="isResult">
                            <transition-group name="expand" tag="div">
                            <a v-for="(user, key) in userlist" class="card-wrapper-link text-left" v-bind:key="user.badgeNumber" @click="bookingData(key)">

                                <b-card class="mb-2" v-show="typing==false && bookTrip==null">
                                    <b-row>
                                        <b-col sm="6">
                                            <p class="text-body-1 m-0 pb-1">Account Title: {{user.accountTitle }}</p>
                                            <p class="text-body-1 m-0 pb-1">Account No: {{user.accountNumber }}</p> 
                                            <p class="text-body-1 m-0">Badge No: {{user.badgeNumber }}</p>
                                        </b-col>
                                        <b-col sm="6">
                                            <p class="text-body-1 m-0 pb-1">Badge itle: {{user.badgeTitle }}</p>
                                            <p class="text-body-1 m-0">Room No: {{user.roomNumber }}</p> 
                                        </b-col>
                                    </b-row>
                                </b-card>

                            </a>
                            </transition-group>
                        </div>
                    </b-col>
                    <b-col sm="12">
                        <div class="mt-4" v-if="bookTrip!=null">
                            <b-row>
                                <b-col sm="6">
                                    <p class="text-body-1 m-0">Trip :{{bookTrip.tripDetails.title}}</p>
                                    <p class="text-body-1 m-0">accountTitle: {{bookTrip.userDetails.accountTitle }}</p>
                                    <p class="text-body-1 m-0">account No:{{bookTrip.userDetails.accountNumber }}</p> 
                                </b-col>
                                <b-col sm="6">
                                    <p class="text-body-1 m-0">badge No:{{bookTrip.userDetails.badgeNumber }}</p>
                                    <p class="text-body-1 m-0">badgeTitle:{{bookTrip.userDetails.badgeTitle }}</p>
                                    <p class="text-body-1 m-0">room No:{{bookTrip.userDetails.roomNumber }}</p> 
                                </b-col>
                                <b-col sm="12" class="text-right">
                                    <div class="mt-4 d-flex justify-content-end">
                                        <button class="btn btn-info">Book Trip</button>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col> -->
                </b-row>    
            </div>
        </b-col>
    </b-row>
</template>

<script>
  import Vue from 'vue'
  // @ is an alias to /src
  import 'vue-search-select/dist/VueSearchSelect.css'
  import { ModelListSelect } from 'vue-search-select'
  import axios from 'axios'
  import Lodash from 'lodash'

  import VueSimpleSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css' // Optional CSS
  

Vue.filter('htmlEscape', function(value) {
  return value.replace(/\&amp\;/g, '&');
});
Vue.filter('dateTime', function(val) {
  return new Date(val).toGMTString().slice(0, -13);
});

export default {
    name: 'booking-events',
    props: {
      selectedEvent: { type: Object, default: () => {} }
    },
    watch: {
        selectedPerson() {
            console.log('this - , ', this.selectedPerson)
        },
        searchQuery: _.debounce(function () {
            this.typing = false
            this.submitSearch(this.searchQuery)
        }, 250)
        
    },
    data () {
        return {
            apiToken         : "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6IndzY290dEBpb2loYW4uY29tIiwidGVuYW50VXNlciI6IjVjYzJhYzQ1ZDBjMmEyNjExYzQ1ZjRmMSIsIklQIjoiOjoxIiwiZG9tYWluIjoibHV0aGVyYW5oYXZlbiIsImFsaWFzIjoiaVdvbGYiLCJ1c2VyVG9rZW5TZXF1ZW5jZSI6OSwiaWF0IjoxNjA0MDMwNDU0LCJleHAiOjE2MDQ3MjE2NTQsImlzcyI6Im9uTG9jYWwifQ.jH54vhSp5sClaJwjU-h5X8ETcYZLYlhU1Af9WbUqbDA",
            apiApplicationKey: "00000-00000-00000-00000-00020",
            //httpHost: "http://sandbox.ioihan.com:9040/api/1",   // from outside development
            httpHost  : "http://localhost:9040/api/1",          // inside ioihan network
            objectItem: {
              badgeTitle:"",
              accountNumber: "",
              badgeNumber:""
            },
            options: [
              { accountNumber: '1', badgeNumber: 'aa' + ' - ' + '1',badgeTitle: "Title 1" },
              { accountNumber: '2', badgeNumber: 'bb' + ' - ' + '2',badgeTitle: "Title 2" },
              { accountNumber: '3', badgeNumber: 'cc' + ' - ' + '3',badgeTitle: "Title 3" },
              { accountNumber: '4', badgeNumber: 'dd' + ' - ' + '4',badgeTitle: "Title 4" },
            ],
            title : this.$route.query.title,
            name,
            selectedPerson: null,
            stringItem    : '',
            bookTrip      : null,
            hoveredIndex  : -1,
            userlist      : null,
            user          : null,
            selected      : null,
            isResult      : false,
            searchQuery   : '',
            typing        : false
            
        }
    },
    computed: {
       httpHeader () {return {
          'headers':{
          'x-access-token': this.apiToken,
          'applicationKey': this.apiApplicationKey,
          'content-Type'  : 'application/json',
          'accept'        : 'application/json'
      }}},
    },
    methods: {
        bookingData(key){
            console.log(key)
                this.bookTrip = {
                        tripDetails: this.selectedEvent,
                        userDetails: this.userlist[key]     
                    } 
        },
        getUserDetails(e) {
            console.log('e - ', e)
        },
        removeSearchQuery: function() {
            this.searchQuery = '';
            this.isResult = false;
        },
        submitSearch: async function(searchString) {
            if( !searchString ) {
              searchString = "a";
            }
            let t = this
            let request = `${t.httpHost}/accountSearch/resident/${searchString}`;
           
            try {
              t.isResult = false;
              let response =  await axios.get(request,t.httpHeader);
              t.userList = response.data;
              t.isResult = true;
              console.log( t.userList );
              // return t.userList.map( t => { return t.badgeTitle; });
              return t.userList;
            } catch( error ) {
              console.log( error ); 
            }
        }
    },
    components: {
      ModelListSelect,
      VueSimpleSuggest
    }
}
</script>

<style lang="scss">
    .trip-info {
        text-align: left;

        .trip-title {
            text-transform: capitalize;
        }
    }
</style>

<style language="scss">

.suggestions {
  /* It's improtant to have a cpecific pivot point for transition:*/
  opacity: 1;
}

.vue-simple-suggest-enter-active.suggestions,
.vue-simple-suggest-leave-active.suggestions {
  /* Transition length here:*/
  transition: opacity .2s;
}

.vue-simple-suggest-enter.suggestions,
.vue-simple-suggest-leave-to.suggestions {
  /* Transition rule for "disengaged" element:*/
  opacity: 0;
}

.removeInput {
  font-size: 36px;
  color: #ddd;
  cursor: pointer;
  top: 0;
  right: 0;
  position: absolute;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
.searchForm {
  margin-bottom: 2.6rem;
  position: relative;  
}

input:focus 		{ outline:none; }

input[type="text"] {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: 2.4375rem;
    border: 0;
    font-family: inherit;
    font-size: 1rem;
    color: #9e9e9e;
    box-shadow: none;
    border-radius: 0;
    transition: box-shadow 0.5s, border-color 0.25s ease-in-out;
    -webkit-appearance: none;
    -moz-appearance: none;
}
input[type="text"] {
  padding: 1rem 0 0.5rem 0;
  margin: 1.75rem 0 0.5rem;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 0;
  background: transparent;
}
input[type="text"]::-webkit-input-placeholder, input[type="text"]::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.26);
}
input[type="text"]:-moz-placeholder, input[type="text"]::-moz-placeholder, input[type="password"]:-moz-placeholder {
  color: rgba(0, 0, 0, 0.26);
}
input[type="text"]:focus {
  border: none;
  border-bottom: 2px solid #000;
  box-shadow: none;
  position: relative;
  top: 1px;
  background: transparent;
}
input[type="text"].with-floating-label + label.floating-label {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.26);
  position: relative;
  top: -35px;
  transition: top .45s ease-in-out, color .45s ease-in-out, font-size .45s ease-in-out;
  height: 0;
  cursor: text;
}
input[type="text"].with-floating-label:focus + label.floating-label, input[type="text"].with-floating-label:valid + label.floating-label {
  color: #00bcd4;
  font-size: 0.75rem;
  top: -56px;
}
.card-wrapper-link:hover .card {
    background: #f5f5f5;
}
</style>

